@import '../../../../../style/lib/scss';
@import '../../../../../style/src/grid-system/mixins';
@import '../../../../../style/src/grid-system/variables';
@import '../mixins';

:host {
	display: block;
}

::slotted(zds-navigation-panel) {
	grid-column-start: 1;
	grid-row-start: 1;
}

::slotted(zds-navigation-body-link) {
	@include zds-media-breakpoint-up('md') {
		max-width: 330px;
		width: 28%;
	}
}

.zds-navigation-body {
	&__body {
		height: 0;
		left: 0;
		opacity: 1;
		overflow: auto;
		position: absolute;
		right: 0;
		top: 100%;
		transition:
			opacity 200ms var(--zds-transition-type-ease-in),
			height 200ms var(--zds-transition-type-ease-in);
		z-index: 1;

		&--close,
		&--closed {
			opacity: 0;
		}

		&--closed {
			display: none;
		}

		@include zds-media-breakpoint-up('md') {
			transition-duration: 400ms;
		}

		&--opened {
			transition:
				opacity 300ms var(--zds-transition-type-ease-out),
				height 300ms var(--zds-transition-type-ease-out);

			@include zds-media-breakpoint-up('md') {
				transition-duration: 500ms;
			}
		}
	}

	&__wrapper {
		display: flex;
		flex-direction: column;
		height: 100%;
		padding-top: var(--zds-space-8);
		position: relative;

		@include make-container;

		@each $breakpoint, $width in $zds-breakpoints {
			@include make-container-breakpoint($breakpoint, $width);
		}

		// Remove the max width for LG viewports
		@include zds-media-breakpoint-down('lg') {
			max-width: 100%;
		}
	}

	@include navigation-body-title;
}
